export const onboardingText = {
  title: "I'm here to:",
  skip: 'Skip for now',
  continue: 'Continue',
};
